import { render } from "./page-preapproval.vue?vue&type=template&id=a0928f3a"
import script from "./page-preapproval.js?vue&type=script&lang=js"
export * from "./page-preapproval.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__